<template>
  <div id="notifyRotate" v-show="!isPortrait">
    <figure>
      <img src="@/assets/notify/rotate.png" alt="" />
      <figcaption>縦画面でお楽しみください</figcaption>
    </figure>
  </div>
</template>

<script>
import { setNeedReload } from "../../util/StoreUtil";

export default {
  name: "NotifyRotate",
  data() {
    return {
      isInit: false,
      isPortrait: true,
      width: 0,
      height: 0,
      orientation: -1
    };
  },
  computed: {
    reload() {
      return this.$store.state.common.needReload;
    }
  },
  mounted() {
    if (this.isInit) return;
    this.check();
    //いきなり横向きならリロード対象にする
    if (!this.isPortrait) {
      setNeedReload();
    }
    window.addEventListener("orientationchange", () => {
      this.check();
    });
    window.addEventListener("resize", () => {
      this.check();
    });
    this.isInit = true;
  },
  methods: {
    check() {
      // this.isPortrait = window.innerHeight > window.innerWidth ;
      this.isPortrait = Math.abs(window.orientation) != 90;
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.orientation = window.orientation;

      if (this.reload && this.isPortrait) {
        location.reload();
      }
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/common"
@import "../../sass/zindex"
#notifyRotate
    position: fixed
    z-index: $z_notify_rotate
    @include fit()
    background-color: #000000
    text-align: center
    font-size: 15px
    line-height: 1
    @include flexCenter()
    img
        width: 135px
        display: block
        margin: 0 auto 50px
</style>
